'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of packed
 */ const Packed = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104 52C104 80.7188 80.7188 104 52 104C23.2812 104 0 80.7188 0 52C0 23.2812 23.2812 0 52 0C80.7188 0 104 23.2812 104 52Z",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M34.034 33.3792L17.8643 33.0379L18.949 34.1802L28.7278 44.3359L44.661 44.3359L34.034 33.3792Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M45.4335 36.2568V32.6863H46.4173C46.8961 32.6863 47.2842 32.2982 47.2842 31.8194V29.6872C47.2842 29.2084 46.8961 28.8203 46.4173 28.8203H31.191C30.7122 28.8203 30.3241 29.2084 30.3241 29.6872V31.8194C30.3241 32.2982 30.7122 32.6863 31.191 32.6863H32.1748V36.2947C31.1593 36.6656 30.2835 37.3327 29.6651 38.2066C29.0466 39.0805 28.7151 40.1193 28.7148 41.1836V58.858C28.7148 59.3368 29.1029 59.7249 29.5817 59.7249H48.1384C48.6172 59.7249 49.0053 59.3368 49.0053 58.858V41.1859C49.0052 40.1016 48.6612 39.0441 48.0211 38.1607C47.381 37.2773 46.4765 36.6118 45.4335 36.2568Z",
                fill: theme.ds5.asset[assetColor].backItem
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.3855 41.4549V38.2365H59.1158C59.5945 38.2365 59.9826 37.8484 59.9826 37.3696V35.904C59.9826 35.4252 59.5945 35.0371 59.1158 35.0371H46.2127C45.734 35.0371 45.3458 35.4252 45.3458 35.904V37.3696C45.3458 37.8484 45.734 38.2365 46.2127 38.2365H46.943V41.4876C46.0666 41.8077 45.3108 42.3835 44.7771 43.1376C44.2434 43.8918 43.9572 44.7883 43.957 45.7068V60.8413C43.957 61.3201 44.3451 61.7082 44.8239 61.7082H60.6011C61.0799 61.7082 61.468 61.3201 61.468 60.8413V45.7088C61.4679 44.773 61.171 43.8604 60.6186 43.098C60.0662 42.3356 59.2856 41.7613 58.3855 41.4549Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30.168",
                y: "28.8301",
                width: "17.2368",
                height: "4.77994",
                rx: "0.596867",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "45.0898",
                y: "35",
                width: "15.0641",
                height: "4.05571",
                rx: "0.596867",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M61.3164 44.332H77.2496V78.371H61.3164V44.332Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M71.9465 33.3714L88.1161 33.0301L87.0315 34.1724L77.2526 44.3281L61.3195 44.3281L71.9465 33.3714Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M28.7227 44.332H61.3132V78.371H28.7227V44.332Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3427_21860)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M49.6944 60.316C49.6944 60.316 49.6944 60.3379 49.6944 60.3598C49.6944 60.535 49.4263 64.2145 44.8019 65.879V63.5794L47.5944 60.6007C47.8402 60.3379 47.8402 59.9217 47.5497 59.6589C47.2817 59.418 46.8572 59.418 46.5891 59.7027L44.8019 61.6301V59.6589C44.8019 59.6589 44.8019 59.6589 44.8019 59.637C45.0253 59.1333 46.0977 57.1621 48.7338 57.1621C48.7561 57.1621 48.7784 57.1621 48.8008 57.1621C49.8508 58.3886 49.6944 60.2941 49.6944 60.316ZM43.4615 61.6301L41.652 59.7027C41.4063 59.4399 40.9818 59.418 40.7137 59.6589C40.4457 59.8998 40.4233 60.3379 40.6691 60.6007L43.4615 63.5794V65.8571C38.8372 64.1926 38.5915 60.4912 38.5691 60.3379C38.5691 60.316 38.5691 60.316 38.5691 60.2941C38.5691 60.2722 38.3904 58.3667 39.4404 57.1402C39.4627 57.1402 39.485 57.1402 39.5297 57.1402C42.1882 57.1402 43.2381 59.1333 43.4615 59.6151C43.4615 59.6151 43.4615 59.6151 43.4615 59.637V61.6301ZM49.605 56.0232C49.4933 55.9137 49.3369 55.848 49.1806 55.8261C46.6561 55.6728 45.003 56.9431 44.1317 58.1258C43.2605 56.9431 41.6297 55.6728 39.0829 55.8261C38.9266 55.8261 38.7702 55.9137 38.6585 56.0232C37.0277 57.6221 37.2064 60.1627 37.2287 60.4036C37.2287 60.5788 37.3404 61.8272 38.167 63.2727C38.9489 64.6525 40.602 66.4704 43.886 67.3903C43.9083 67.3903 43.9307 67.3903 43.9307 67.4122C43.953 67.4122 43.953 67.4122 43.9754 67.4122C43.9977 67.4122 43.9977 67.4122 44.02 67.4122C44.0424 67.4122 44.0871 67.4122 44.1094 67.4122C44.1317 67.4122 44.1764 67.4122 44.1988 67.4122C44.2211 67.4122 44.2211 67.4122 44.2434 67.4122C44.2658 67.4122 44.2658 67.4122 44.2881 67.4122C44.3105 67.4122 44.3328 67.4122 44.3551 67.3903C50.4539 65.7038 50.9901 60.8854 51.0124 60.4255C51.0348 60.2941 51.2582 57.6659 49.605 56.0232Z",
                    fill: theme.ds5.asset.grey["700"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_21860",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "14.0741",
                        height: "11.827",
                        fill: "white",
                        transform: "translate(37.0947 55.7168)"
                    })
                })
            })
        ]
    });
};

exports.Packed = Packed;
//# sourceMappingURL=Packed.cjs.map
